module.exports = __webpack_public_path__ + "img/linkedin-logo.bde18435.svg";